/* eslint-disable id-match */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { formatCurrency } from '../../../../helpers/currency';
import ThemeContext from '../../../../providers/ThemeProvider';

const BookingAlternativeDiff = ({ diff, isInternal }) => {
  const theme = useContext(ThemeContext);
  let formattedDiff = formatCurrency(
    process.env.NEXT_PUBLIC_COUNTRY_CODE,
    diff,
    true,
    false,
  );
  if (diff > 0) formattedDiff = `+ ${formattedDiff}`;

  return (
    <>
      <div
        className={classNames('diff-wrapper', {
          'diff-wrapper--isInternal': isInternal,
        })}
      >
        <span
          className={classNames('diff', {
            'diff--isInternal': isInternal,
          })}
        >
          {formattedDiff}
        </span>
      </div>
      <style jsx>{`
        .diff-wrapper {
          margin-bottom: 10px;
          text-align: right;
        }

        .diff-wrapper--isInternal {
          margin-bottom: 0;
          text-align: left;
        }

        .diff {
          background: ${theme.commoncolors.greyshade};
          border: 0;
          color: ${theme.commoncolors.white};
          cursor: pointer;
          display: inline-block;
          height: 22px;
          line-height: 22px;
          padding: 0 10px 0 30px;
          position: relative;
          top: -1px;
        }

        .diff:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          border-top: 22px solid ${theme.commoncolors.greyshade};
          border-left: 22px solid ${theme.commoncolors.white};
          width: 0;
        }

        .diff--isInternal {
          background: none;
          color: ${theme.colors.primary};
          font-size: 17px;
          font-weight: bold;
          padding: 0 10px 0 0;
        }

        .diff--isInternal:before {
          border: none;
        }
      `}</style>
    </>
  );
};

BookingAlternativeDiff.propTypes = {
  diff: PropTypes.number.isRequired,
  isInternal: PropTypes.bool,
};

export default BookingAlternativeDiff;
